import { Route, Routes } from 'react-router-dom'

import { FC } from 'react'
import { SellerPotentialAnalytics } from './SellerPotentialAnalytics'

const SellerPotentialPage: FC = () => (
  <Routes>
    <Route index element={<SellerPotentialAnalytics />} />
  </Routes>
)

export default SellerPotentialPage
